// extracted by mini-css-extract-plugin
module.exports = {"wave_box":"ParkRoad_wave_box__3eD4y","wave_box_title":"ParkRoad_wave_box_title__1HuSQ","wave_item":"ParkRoad_wave_item__3iB2_","wave_item_label":"ParkRoad_wave_item_label__2ZFAa"};